import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityUptimeMonitorsDashboard } from '@api/data-security';

export const getCoreDataSecurityUptimeMonitorsDashboardSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityUptimeMonitorsDashboard',
	receive: true,
	request: true,
	requestHandler: getDataSecurityUptimeMonitorsDashboard,
	retainDataOnRequest: true
});
